import React from 'react';

/**
 * KanAIStreamingCaret — blinkande caret som signalerar att text fortfarande
 * strömmar in. Renderas som sista barn i den löpande textens container.
 */
export default function KanAIStreamingCaret() {
  return <span className="kp-kanai-caret" aria-hidden="true" />;
}
